var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageFill = function SvgImageFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 810.66V213.33c0-46.93-38.4-85.33-85.34-85.33H213.33C166.4 128 128 166.4 128 213.33v597.33c0 46.94 38.4 85.34 85.33 85.34h597.33c46.94 0 85.34-38.4 85.34-85.34M379.73 596.48l89.6 107.94L601.6 534.18c8.54-11.09 25.6-11.09 34.14.43L785.5 734.29c10.66 14.08.42 34.13-17.07 34.13H256.85c-17.92 0-27.73-20.48-16.64-34.56l106.24-136.53c8.11-11.1 24.32-11.52 33.28-.86Z"
  })));
};
export default SvgImageFill;